import { tsValidateArray, tsValidateDynamicObject, tsValidateNumber, tsValidateOptionalId, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { PermissionDBGroup } from '../../consts.js';
import { validateGroupLabel } from '../../validators.js';
const Validator_ModifiableProps = {
    label: validateGroupLabel,
    uiLabel: tsValidateString(),
    projectId: tsValidateOptionalId,
    accessLevelIds: tsValidateArray(tsValidateUniqueId, false),
};
const Validator_GeneratedProps = {
    _levelsMap: tsValidateDynamicObject(tsValidateNumber(), tsValidateString(), false),
    _auditorId: tsValidateString(),
};
export const DBDef_PermissionGroup = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'permissions--group',
    entityName: 'PermissionGroup',
    frontend: {
        group: PermissionDBGroup,
        name: 'group',
    },
    backend: {
        name: 'permissions--group'
    },
    dependencies: {
        projectId: {
            dbKey: 'permissions--project',
            fieldType: 'string',
        },
        accessLevelIds: {
            dbKey: 'permissions--level',
            fieldType: 'string[]',
        }
    }
};
//# sourceMappingURL=db-def.js.map